import { UndefinedContent, type XYChartState } from '../types/state.js';

export function reducePanDomain(domain: XYChartState['currentDomain']) {
  return (prev: XYChartState): XYChartState => ({
    ...prev,
    currentDomain: domain,
    explore: { visible: false, pinned: false, content: UndefinedContent },
    highlightedSeriesIds: undefined,
    select: undefined,
  });
}
